<template>

  <div class="map-list-wrapper" :class="{'list-view': listVisible}">
    <div class="container">
      <div class="view-toggle-wrapper">
        <router-link href="#" to="/WAT50N/map" @click.prevent="showMap" class="btn btn-view-toggle">
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 5.5c0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5v16c0 .2761424-.22385763.5-.5.5-.27614237 0-.5-.2238576-.5-.5v-16zm8 5c0 .2761424-.2238576.5-.5.5s-.5-.2238576-.5-.5V.5c0-.27614237.2238576-.5.5-.5s.5.22385763.5.5v10zM7.49999031 20.8855413l5.70937779-4.0783989c.2247012-.1605116.5369779-.1084756.6974895.1162257.1605116.2247012.1084756.5369779-.1162257.6974895l-5.99999997 4.286c-.17384956.1241865-.40739755.1241902-.58125103.0000091l-7-5C.07798284 16.813011 0 16.6614756 0 16.5V.5C0 .09331372.45968486-.14324833.7906191.09313326L7.5 4.8855482 14.2093809.09313326c.1738488-.12417768.4073894-.12417768.5812382 0l7 5C21.9220172 5.18698902 22 5.33852445 22 5.5v5c0 .2761424-.2238576.5-.5.5s-.5-.2238576-.5-.5V5.75730895L14.5 1.1144518 7.7906191 5.90686674c-.17384876.12417768-.40738944.12417768-.5812382 0L1 1.47159466V16.2426911l6.49999031 4.6428502z"/>
            <path d="M19.7298535 22.410526c.4626931-.5967776.9253539-1.2275809 1.3563917-1.8628768.3161119-.4659093.6030907-.916805.8540592-1.3459888C22.6214635 18.0368031 23 17.0909932 23 16.5c0-1.9328576-1.5671424-3.5-3.5-3.5-1.9334929 0-3.5 1.5667776-3.5 3.5 0 .5909932.3785365 1.5368031 1.0596956 2.7016604.2509685.4291838.5379473.8800795.8540592 1.3459888.4310378.6352959.8936986 1.2660992 1.3563917 1.8628768.0823909.1062672.1592832.2044439.2298535.2937687.0705703-.0893248.1474626-.1875015.2298535-.2937687zM24 16.5c0 .8207223-.4307758 1.8970571-1.1964523 3.2064484-.2630218.4497965-.5618093.9192456-.8897929 1.4026524-.4439622.6543447-.9188014 1.3017524-1.3936083 1.9141544-.1662019.2143658-.3206346.4091782-.4594125.5808737-.0837463.1036107-.1440169.1769093-.176919.2163178-.1998785.2394044-.5677515.2394044-.76763 0-.0329021-.0394085-.0931727-.1127071-.176919-.2163178-.1387779-.1716955-.2932106-.3665079-.4594125-.5808737-.4748069-.612402-.9496461-1.2598097-1.3936083-1.9141544-.3279836-.4834068-.6267711-.9528559-.8897929-1.4026524C15.4307758 18.3970571 15 17.3207223 15 16.5c0-2.4854685 2.0141837-4.5 4.5-4.5 2.4851424 0 4.5 2.0148576 4.5 4.5z"/>
            <path d="M19.5 18.5c-1.1045695 0-2-.8954305-2-2s.8954305-2 2-2 2 .8954305 2 2-.8954305 2-2 2zm0-1c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1-1 .4477153-1 1 .4477153 1 1 1z"/>
          </svg>
          <span class="hidden-xs">View By Map</span>
        </router-link>

        <router-link to="/WAT50N/map/list" href="#" @click.prevent="showList" class="btn btn-view-toggle" :class="{'list-active': this.$route.path.includes('list')}">
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="currentColor">
            <path d="M2.5 7C1.11928813 7 0 5.88071187 0 4.5S1.11928813 2 2.5 2 5 3.11928813 5 4.5 3.88071187 7 2.5 7zm0-1C3.32842712 6 4 5.32842712 4 4.5S3.32842712 3 2.5 3 1 3.67157288 1 4.5 1.67157288 6 2.5 6zm6.069-1.072c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5H23.5c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5H8.569zM2.5 15C1.11928813 15 0 13.8807119 0 12.5S1.11928813 10 2.5 10 5 11.1192881 5 12.5 3.88071187 15 2.5 15zm0-1c.82842712 0 1.5-.6715729 1.5-1.5S3.32842712 11 2.5 11 1 11.6715729 1 12.5 1.67157288 14 2.5 14zm6.069-1.072c-.27614237 0-.5-.2238576-.5-.5s.22385763-.5.5-.5H23.5c.2761424 0 .5.2238576.5.5s-.2238576.5-.5.5H8.569zM2.5 23C1.11928813 23 0 21.8807119 0 20.5S1.11928813 18 2.5 18 5 19.1192881 5 20.5 3.88071187 23 2.5 23zm0-1c.82842712 0 1.5-.6715729 1.5-1.5S3.32842712 19 2.5 19 1 19.6715729 1 20.5 1.67157288 22 2.5 22zm6.069-1.073c-.27614237 0-.5-.2238576-.5-.5s.22385763-.5.5-.5H23.5c.2761424 0 .5.2238576.5.5s-.2238576.5-.5.5H8.569z"/>
          </svg>
          <span class="hidden-xs">View By List</span>
        </router-link>
      </div>
      <h2 class="text-center text-gray">Since <span class="text-success">1969</span>, over <span class="text-success">3000</span> Watson fellows have discovered the world.</h2>
      <div class="year-controls font-sans">

        <label class="custom-radio" id="radioAllYears" :class="{'selected' : yearFilter == 'allYears' }">All Years
          <input type="radio" name="radioYear" value="allYears" @change="updateYearFilter" checked>
          <span class="checkmark"></span>
        </label>

        <label class="custom-radio" id="radioSingleYear" :class="{'selected' : yearFilter == 'singleYear' }">Specific Year:
          <input type="radio" name="radioYear" value="singleYear" @change="updateYearFilter">
          <span class="checkmark"></span>
        </label>
        <div class="d-flex">
          <label>1969</label>

          <div class="slider-wrapper" :class="{'active' : yearFilter == 'singleYear' }">
            <label class="year-chosen" v-if=" yearFilter == 'singleYear' " :style="{ left: sliderKnobPosition}">{{ sliderValue }}</label>
            <range-slider
              class="slider"
              min="1969"
              :max="currentYear"
              step="1"
              v-model="sliderValue" @change="updateYear">
            </range-slider>
          </div>
          <label>{{ currentYear }}</label>
        </div>
      </div>
    </div>

    <div id="loading" v-if="loading">
      <img src="/images/watson-loading.gif" alt="Loading"/>
    </div>
    <router-view :continents="continents" :filter="filter" :loading="loading"></router-view>
  </div>
</template>

<script>

import RangeSlider from 'vue-range-slider'


export default {

  props: ['continents', 'filter', 'loading'],
  data(){
    return{
      sliderValue: 1969,
      yearFilter: 'allYears',
      mapVisible: false,
      listVisible: true
    }
  },
  computed: {

    sliderKnobPosition() {
      const numberOfYears = this.currentYear - 1969
      const percentage = ((this.sliderValue - 1969) / numberOfYears) * 100

      return percentage.toString() + '%'
    },
    currentYear() {
      return (new Date()).getFullYear()
    }
  },
  methods: {
    showMap() {
      this.mapVisible = true
      this.listVisible = false
    },

    showList() {
      this.listVisible = true
      this.mapVisible = false
    },

    updateYear() {
      this.$emit('updateyear', this.sliderValue);
    },

    updateYearFilter(e) {
      this.yearFilter = e.target.value
      if (this.yearFilter == 'singleYear') {
        this.$emit('updateyear', this.sliderValue);
      } else {
        this.$emit('updateyear', '');
      }
    },

  },

  mounted() {

  },

  components: {
    RangeSlider
  }
}
</script>

<style lang="scss">
@import '../node_modules/vue-range-slider/dist/vue-range-slider.css';

#mapApp {

  .map-list-wrapper {
    background-color: #C9E0DF;
    padding-top: 30px;
    position: relative;
    &.list-view{
      background-color: #ffffff;
    }
  }

  #loading {
    position: absolute;
    // z-index: 999999;
  }

  label{
    color: #333;
  }
  a{
    text-decoration: none;
  }


  .view-toggle-wrapper {
    display: flex;
    justify-content: center;
  }

  .btn-view-toggle {
    border-radius: 0;
    border: 1px solid #333333;
    color: #333333;
    background-color: white;
    display: flex;
    align-items: center;
    padding: 10px 20px;

    & svg{
      display: block;
      margin-right: 10px;
    }

    &:first-child {
      margin-right: 1rem;
    }

    &.router-link-exact-active, &.list-active, &:hover {
    color: white;
    background-color: #333333;
    }
  }

  .year-controls{
    margin: 20px 0;
    font-weight: 800;
    letter-spacing: .5px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 500px) {
      display: block;
    }
    & .d-flex{
      align-items: center;
    }
  }
  .slider-wrapper {
    display: inline-block;
    position: relative;
    margin: 0 14px;
    .year-chosen {
      display: block;
      position: absolute;
      top: -15px;
      text-align: center;
      transform: translateX(-20px);
      color: #f53d46;
    }

    .range-slider {
      padding: 0;
    }
  }
  .slider {
    width: 400px;
    margin: 10px 0;
    @media (max-width: 500px) {
      width: 200px;
    }
  }

  .range-slider-knob{
    background-color: white;
    box-shadow: none;
  }

  .range-slider-rail, .range-slider-fill{
    height: 2px;
    background-color: #585858;
  }
  .slider-wrapper.active{
    & .range-slider-knob{
      background-color: #f53d46;
    }
    & .range-slider-fill{
      background-color: #f53d46;
    }
  }


  #alumniMap {
    height: calc(100vh - 100px);
    max-height: 900px;
  }
  .hidden {
    opacity: 0;
  }


  .link-continent {
    text-decoration: none;
    display: block;
    &:hover .heading-continent{
      color: #111111;
    }
    &:hover .heading-continent::after{
      border-left-color: #111111;
    }
  }

  .heading-continent {
    margin: 15px 0;
    &::after {
      content: "";
      display: inline-block;
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 10px solid #f53d46;
      margin-left: 2rem;
      transition: transform 0.3s;
    }

    &.open {
      &::after {
        transform: rotateZ(90deg);
      }
    }
  }
  .countries-wrapper, .list-fellows-wrapper {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s;

    &.open {
      max-height: 10000px;
    }
  }
  // .countries-wrapper.open {
  //   max-height: 10000px;
  // }

  // .list-fellows-wrapper.open {
  //   overflow: scroll;
  //   max-height: 100vh;
  // }

  .country-wrapper {
    border-bottom: 2px solid #cccccc;
    &.open{
      background-color: white;
      border-color: white;
      & .heading-country {
        color: #f53d46;
      }
    }
  }

  .link-country {
    text-decoration: none;
    display: block;
    &:hover{
      background-color: white;
    }
    & .d-flex{
      justify-content: space-between;
      align-items: center;
    }

    & .open-indicator {
      width: 30px;
      height: 30px;
      border: 1px solid #f53d46;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #f53d46;
      font-size: 37px;
      transition: transform 0.3s;

      &.open {
        transform: rotateZ(45deg);
      }
    }
  }

  .heading-country {
    color: #585858;
    margin: 15px 0;
  }
  
  .list-fellows-wrapper{
    & .btn-view-toggle{
      display: inline-flex;
      padding: 8px;
      border-radius: 50%;
      & svg{
        margin: 0;
      }
    }
    &.open {
      background-color: white;
      border-bottom: 2px solid #cccccc;
    }  
  }

  .fellows-heading {
    margin-top: 0;
    margin-bottom: 1rem;
    display: inline-block;

    & small{
      display: inline-block;
      margin-right: 15px;
    }
  }

  .heading-fellow-type{
    margin-top: 20px;
    margin-bottom: 0px;
  }

  .fellow {
    h4 {
      margin: 0;
    }
  }

  /*info window styles*/

  .gm-style .gm-style-iw {
    margin: 0;
    padding: 0;
    & h5{
      margin: 5px 0;
      color: #f53d46;
    }
    & span{
      font-weight: 400;
      margin-right: 10px;
    }
  } 

  .flag-emoji {
    font-size: 26px;
    margin-right: 10px;
  }


  /* radio button styles */
  .custom-radio {
    display: block;
    position: relative;
    cursor: pointer;
    padding-left: 2.5rem;
    font-family: Avenir;
    color: #333;

    &.selected {
      color: #f53d46;

      .checkmark {
        border: 1.5px solid #f53d46;
      }

      .checkmark:after {
        display: block;
      }
    }

    input[type="radio"] {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: white;
        border-radius: 50%;
        border: 1.5px solid #333333;
    }

    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .checkmark:after {
      top: 4px;
      left: 50%;
      transform: translateX(-50%);
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #f53d46;
    }
  }

  #radioAllYears {
    margin-right: 3rem;
  }

  #radioSingleYear {
    margin-right: 1rem;
  }
}

</style>



// WEBPACK FOOTER //
// scripts/map.vue